import {debounceTime} from 'rxjs/operators';
import {Component, Input, OnInit, Output, EventEmitter, OnChanges} from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import _ from 'lodash';
import {DataHandlerService} from '../../../services/data-handler.service';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import {
  SensisMobileComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/sensis-mobile/sensis-mobile.component';
import {
  SensisEmailComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/sensis-email/sensis-email.component';

@Component({
    selector: 'app-customer-details',
    templateUrl: 'customer-details.component.html',
    standalone: true,
    imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule,
      MatInputModule, MatInputModule, ValidationPartialComponent, SensisMobileComponent, SensisEmailComponent]
})
export class CustomerDetailsComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;
  @Output() public customerDetailsChange = new EventEmitter<any>();

  private _customer = {
    name: '',
    email: '',
    phone: ''
  };

  constructor(public dataHandlerService: DataHandlerService) {
    super(dataHandlerService);
  }

  ngOnInit() {
    this.formGroup.get('name').valueChanges.pipe(
      debounceTime(500))
      .subscribe((val) => {
        console.debug('CustomerDetailsComponent.formGroup.name');
        this._customer['name'] = _.trim(val);
        this.emitCustomer();
      });

    this.formGroup.get('email').valueChanges.pipe(
      debounceTime(500))
      .subscribe((val) => {
        console.debug('CustomerDetailsComponent.formGroup.email');
        this._customer['email'] = _.trim(val);
        this.emitCustomer();
      });

    this.formGroup.get('phone').valueChanges.pipe(
      debounceTime(500))
      .subscribe((val) => {
        console.debug('CustomerDetailsComponent.formGroup.phone');
        this._customer['phone'] = _.trim(val);
        this.emitCustomer();
      });
  }

  ngOnChanges(changes) {
    if (changes['formGroup']['firstChange']) {
      if (changes['formGroup']['currentValue']['value']['name']) {
        this._customer['name'] = changes['formGroup']['currentValue']['value']['name'];
      }
      if (changes['formGroup']['currentValue']['value']['email']) {
        this._customer['email'] = changes['formGroup']['currentValue']['value']['email'];
      }
      if (changes['formGroup']['currentValue']['value']['phone']) {
        this._customer['phone'] = changes['formGroup']['currentValue']['value']['phone'];
      }
      if (this._customer && this._customer.name && this._customer.email && this._customer.phone) {
        this.emitCustomer();
      }
    }
  }

  public emitCustomer() {
    this.customerDetailsChange.emit(this._customer);
  }
}


